import React from 'react';
import { Grid, Paper, FormControlLabel, Checkbox } from '@material-ui/core';

function SearchForm(props) {
    const { values } = props;
    const { checked, chartParam } = values;
    const conditionChange = (event) => {
        props.setChartVisibleStyle({visibility: 'hidden'});
        props.checkboxHandleChange(event); 
    }
    return (
        <div className="search-form">
            <Grid container alignItems="center" spacing={0}>
                <Grid item xs={3} sm={4} className="search-dt" id="ketashu">
                    <Paper className="search-paper">
                        桁 種
                    </Paper>
                </Grid>
                <Grid item xs={9} sm={8} className="search-dd">
                <Paper className="search-paper">
                    <Grid container alignItems="center" spacing={0}>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Checkbox onChange={conditionChange} name="ketashuKubun" value="1" color="primary" checked={checked.ketashuKubun['1']} />}
                                label="鋼橋　　　"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControlLabel
                                control={<Checkbox onChange={conditionChange} name="ketashuKubun" value="2" color="primary" checked={checked.ketashuKubun['2']} />}
                                label="コンクリート橋"
                            />
                        </Grid>
                    </Grid>
                </Paper>
                </Grid>
                {chartParam.sekkeiKubun === '1' && (
                    <React.Fragment>
                        <Grid item xs={12} className="search-hr"/>
                        <Grid item xs={3} sm={4} className="search-dt" id="keikan">
                            <Paper className="search-paper">
                                径 間
                            </Paper>
                        </Grid>
                        <Grid item xs={9} sm={8} className="search-dd">
                            <Paper className="search-paper">
                                <Grid container alignItems="center" spacing={0}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControlLabel
                                            control={<Checkbox onChange={conditionChange} name="keikan" value="1" color="primary" checked={checked.keikan[1]} />}
                                            label="１径間　　"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControlLabel
                                            control={<Checkbox onChange={conditionChange} name="keikan" value="2" color="primary" checked={checked.keikan[2]} />}
                                            label="２～４径間"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>                                        
                                        <FormControlLabel
                                            control={<Checkbox onChange={conditionChange} name="keikan" value="3" color="primary" checked={checked.keikan[3]} />}
                                            label="５～７径間"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControlLabel
                                            control={<Checkbox onChange={conditionChange} name="keikan" value="4" color="primary" checked={checked.keikan[4]} />}
                                            label="８径間以上"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </React.Fragment>
                )}
                <Grid item xs={12} className="search-hr"/>
                <Grid item xs={3} sm={4} className="search-dt" id="area">
                <Paper className="search-paper">
                    地 域
                </Paper>
                </Grid>
                <Grid item xs={9} sm={8} className="search-dd">
                    <Paper className="search-paper">
                        <Grid container alignItems="center" spacing={0}>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="01" color="primary" checked={checked.area['01']} />}
                                    label="北海道"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="02" color="primary" checked={checked.area['02']} />}
                                    label="東北"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="03" color="primary" checked={checked.area['03']} />}
                                    label="関東"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="04" color="primary" checked={checked.area['04']} />}
                                    label="中部"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="05" color="primary" checked={checked.area['05']} />}
                                    label="北陸"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="06" color="primary" checked={checked.area['06']} />}
                                    label="近畿"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="07" color="primary" checked={checked.area['07']} />}
                                    label="中国"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="08" color="primary" checked={checked.area['08']} />}
                                    label="四国"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControlLabel
                                    control={<Checkbox onChange={conditionChange} name="area" value="09" color="primary" checked={checked.area['09']} />}
                                    label="九州沖縄"
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default SearchForm;
